import React from 'react';
import { Button, ButtonProps } from '@mui/material';
import { Check as CheckIcon } from '@mui/icons-material';

interface SaveButtonProps extends Omit<ButtonProps, 'variant' | 'color'> {
  saving?: boolean;
}

export const SaveButton: React.FC<SaveButtonProps> = ({
  saving = false,
  disabled,
  children = '保存',
  sx,
  ...props
}) => {
  return (
    <Button
      variant="contained"
      startIcon={<CheckIcon />}
      disabled={disabled || saving}
      sx={{
        backgroundColor: '#FF9800',
        borderRadius: '8px',
        color: '#FFFFFF',
        textTransform: 'none',
        fontSize: '16px',
        fontWeight: 500,
        px: 3,
        py: 1,
        '&:hover': {
          backgroundColor: '#F57C00',
        },
        '&.Mui-disabled': {
          backgroundColor: '#CCCCCC',
        },
        ...sx,
      }}
      {...props}
    >
      {children}
    </Button>
  );
};

